import React from 'react';
import './ProfileSubviewHeader.scss';

interface ProfileSubviewHeaderProps {
  title: string;
  onBack: () => void;
}

/**
 * Shared back-header for profile subviews (My listings, Price estimations,
 * Notification settings). New-UI style: circular back button + 22px SemiBold
 * title, replacing the three per-page duplicated back-header blocks (JAA-308).
 */
const ProfileSubviewHeader: React.FC<ProfileSubviewHeaderProps> = ({ title, onBack }) => (
  <div className="profile-subview-header">
    <button
      className="profile-subview-header__back"
      onClick={onBack}
      type="button"
      aria-label="Back"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
    <h1 className="profile-subview-header__title">{title}</h1>
  </div>
);

export default ProfileSubviewHeader;
